module.exports = __webpack_public_path__ + "media/assets/badges/Clutch-d4a153475c3d44c1f9b0509b0b3ab4c5.svg";